<template>
    <div class="stepper d-flex justify-content-center flex-row pt-5 pb-4">
        <div v-for="(item, index) in steps"
             :key="index"
             class="d-flex justify-content-center flex-row">
            <div class="rounded-circle text-center stepper__circle"
                 :class="{ active: step >= index }">
                {{ index+1 }}
            </div>
            <div v-if="index != steps.length"
                 class="stepper__line"
                 :class="{ active: step >= index}">
                <div class="px-2 pb-1 text-center">{{item}}</div>
                <div class="line"
                     :class="{ 'not-last': index !== steps.length-1&&step >= index, gradient: index == steps.length-1&&step >= index}"></div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="rounded-circle text-center stepper__circle last">
                <b-icon-check />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Stepper',
    props: {
        steps: Array,
        step: Number
    }
};
</script>

<style scoped lang="scss">
.stepper {
    .stepper__circle {
        width: 20px;
        height: 20px;
        border-radius: 20px;
        font-size: 12px;
        line-height: 20px;
        background-color: #e9e9e9;
        color: #c4c4c4;
        &.active {
            background-color: $primary;
            cursor: none;
            color: #fff;
        }
    }
    .stepper__line {
        position: relative;
        top: -15px;
        font-size: 14px;
        width: 100px;
        &.active {
            color: $primary;
        }
        .line {
            width: 100%;
            height: 3px;
            position: absolute;
            bottom: 0;
            background: #e9e9e9;
            &.gradient {
                background: linear-gradient(to right, #0188d1, #02b6b3);
            }
            &.not-last {
                background: $primary;
            }
        }
        @media (max-width: 414px) {
            & {
                width: auto;
            }
        }
        @media (max-width: 340px) {
            & {
                font-size: 12px;
                top: -10px;
            }
        }
    }
    .last {
        font-size: 14px;
    }
}
</style>
